/** Legacy global work routes — redirect to module-scoped paths via LegacyWorkRouteRedirect. */
export const LEGACY_GLOBAL_WORK_ROUTES = [
  '/work',
  '/work/executive',
  '/work/approvals',
  '/notifications',
  '/approvals',
] as const;

export function isLegacyGlobalWorkRoute(pathname: string): boolean {
  const path = pathname.split('?')[0];
  return LEGACY_GLOBAL_WORK_ROUTES.some((r) => path === r || path.startsWith(`${r}/`));
}

/** @deprecated Work is module-scoped; only legacy redirects remain global. */
export const GLOBAL_WORKSPACE_ROUTES = LEGACY_GLOBAL_WORK_ROUTES;

export function isGlobalWorkspaceRoute(pathname: string): boolean {
  return isLegacyGlobalWorkRoute(pathname);
}
